<template>
    <div class='course-card-info'>
        <span>已报</span><span><i
            class="icon-set_sns"></i>{{countdata}}</span><span>人</span>
        <span v-show="countdata > 0" class="course-star-box">
            <i v-show="countdata >= 1" class="icon-star2 on"></i>
            <i v-show="countdata > 5" class="icon-star2 on"></i>
            <i v-show="countdata > 10" class="icon-star2 on"></i>
            <i v-show="countdata > 20" class="icon-star2 on"></i>
            <i v-show="countdata > 30" class="icon-star2 on"></i>
        </span>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "allcount",
        props: ["work"],
        data() {
            return {
                workdata: {},
                countdata: 0,
            }
        },
        components: {
            axios
        },
        methods: {
            getworknumber(leibie, xinagmu) {
                var params = {
                    "tenantId": "1",
                    "leibie": leibie,
                    "xinagmu": xinagmu,
                }

                axios.post("/Api/getworkscount", params).then(res => {
                    this.countdata = res.data.result;
                })
            },
        },
        mounted: function () {
            this.getworknumber(this.work.gzleibie, this.work.gzxiangmu);
        },
    }
</script>

<style>
    .on {
        color: #f90 !important;
    }
</style>